import Vue from 'vue'
import Router from 'vue-router'
import Util from './utils/util';
import Home from './views/Home'
import Login from './views/Login'
import Logout from './views/Logout'
import Message from './views/Message'
import NotFound from './views/NotFound'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      beforeEnter: (to,from,next) => {
        if ( Util.getToken() === '' ) {
          next('login');
        }else{
          next();
        }
      }
    },
    {
      path: "/message",
      name: 'message',
      component: Message,
      beforeEnter: (to,from,next) => {
        if ( Util.getToken() === '' ) {
            next('login');
        }else{
          next();
        }
      }
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: (to,from,next) => {
        if ( Util.getToken() === '' ) {
          next('login');
        }else{
          next();
        }
      }
    },
    {
      path: '*',
      name: 'notfound',
      component: NotFound,
    }
  ]
})
